import React from 'react'
import {
  Definition,
  Section,
  SectionHeader,
  SectionBody,
} from '@apexinternal/ui-components'
import { BoxProps } from '@chakra-ui/react'
import { isEmpty, startCase, lowerCase } from 'lodash'
import { InvestmentProfile } from 'types'
import { formatDollarRange } from './utils'

export interface InvestmentProfileTableProps extends BoxProps {
  investmentProfile?: InvestmentProfile
}

const InvestmentProfileTable = ({
  investmentProfile,
  ...rest
}: InvestmentProfileTableProps) => {
  if (isEmpty(investmentProfile) || !investmentProfile) return null
  const {
    investmentObjective,
    investmentExperience,
    riskTolerance,
    annualIncomeUSD,
    liquidNetWorthUSD,
    totalNetWorthUSD,
    federalTaxBracketPercent,
  } = investmentProfile
  return (
    <Section {...rest}>
      <SectionHeader>Investment Profile</SectionHeader>
      <SectionBody>
        {investmentObjective && (
          <Definition
            role="row"
            key="investmentObjective"
            data-testid="investmentObjective"
            term="Investment Objective"
            definition={startCase(lowerCase(investmentObjective))}
          />
        )}
        {investmentExperience && (
          <Definition
            role="row"
            key="investmentExperience"
            data-testid="investmentExperience"
            term="Investment Experience"
            definition={startCase(lowerCase(investmentExperience))}
          />
        )}
        {riskTolerance && (
          <Definition
            role="row"
            key="riskTolerance"
            data-testid="riskTolerance"
            term="Risk Tolerance"
            definition={startCase(lowerCase(riskTolerance))}
          />
        )}
        {annualIncomeUSD && (
          <Definition
            role="row"
            key="annualIncomeUSD"
            data-testid="annualIncomeUSD"
            term="Annual Income"
            definition={formatDollarRange(annualIncomeUSD)}
          />
        )}
        {liquidNetWorthUSD && (
          <Definition
            role="row"
            key="liquidNetWorthUSD"
            data-testid="liquidNetWorthUSD"
            term="Liquid Net Worth"
            definition={formatDollarRange(liquidNetWorthUSD)}
          />
        )}
        {totalNetWorthUSD && (
          <Definition
            role="row"
            key="totalNetWorthUSD"
            data-testid="totalNetWorthUSD"
            term="Total Net Worth"
            definition={formatDollarRange(totalNetWorthUSD)}
          />
        )}
        {federalTaxBracketPercent && (
          <Definition
            role="row"
            key="federalTaxBracketPercent"
            data-testid="federalTaxBracketPercent"
            term="Federal Tax Bracket"
            definition={`${federalTaxBracketPercent}%`}
          />
        )}
      </SectionBody>
    </Section>
  )
}

export default InvestmentProfileTable
